/* global axios */
import ApiClient from '../ApiClient';

class CrmFollowUpRulesAPI extends ApiClient {
  constructor() {
    super('crm_follow_up_rules', {
      saas: true,
      accountScoped: true,
    });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  create(data) {
    return axios.post(this.url, { crm_follow_up_rule: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { crm_follow_up_rule: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CrmFollowUpRulesAPI();
